import { ReactComponent as LogoIcon } from '@/assets/img/icon/logo.svg'
import { ReactComponent as MenuCloseIcon } from '@/assets/img/icon/menu-close.svg'
import { ReactComponent as MenuOpenIcon } from '@/assets/img/icon/menu-open.svg'
import { LoadingOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { Component, useEffect, useRef } from 'react'
//路由
import { BrowserRouter, withRouter } from 'react-router-dom'
import './App.less'
//其他样式
import './assets/css/common.css'
import './assets/css/houtai.css'
import { ElectronComponentShow } from './components/Common/ElectronComponent'
import { ElectronUpdater } from './components/Common/ElectronUpdater'
import ContentMain from './components/ContentMain'; //主题
//布局组件
import CustomMenu from './components/Menu/index'; //导航
import AddNoteModal from './components/Modal/AddNoteModal'
import AddToLabelModal from './components/Modal/AddToLabelModal'
import FreeNumberExpiredModal from './components/Modal/FreeNumberExpiredModal'
import GetFreeNumberModal from './components/Modal/GetFreeNumberModal'
import OnlineDocPreviewModal from './components/Modal/OnlineDocPreviewModal'
import SubScriptionExpired from './components/Modal/SubScriptionExpired'
import VerifyEmailModal from './components/Modal/VerifyEmailModal'
import SearchTop from './components/SearchTop/index'; //搜索
import { Config, IS_DEV, IS_ELECTRON } from './utils/config'
import { getCookieToken } from './utils/cookie'
import { ipcSendCocoFaxAction } from './utils/ipcRenderer'
import sa from './utils/statis'

// import history from './router/history'

// const App2 = () => {
//   const [faxVisible, setFaxVisible] = useState(false);
//   const [pdfSrc, setPdfSrc] = useState('');
//   const [sideFlag, setSlideFlag] = useState(true);

// }

const PDFView = (props) => {
  const { src, onDownFileClick, onClose } = props
  const actived = src ? true : false
  const wrapRef = useRef()
  const iframeRef = useRef()

  // const renderSrc = actived ? ("https://drive.google.com/viewerng/viewer?url=" + encodeURIComponent(src)) : ""
  const renderSrc = actived ? src : ""

  useEffect(() => {
    if (actived && wrapRef.current && iframeRef.current) {
      const { width, height } = wrapRef.current.getBoundingClientRect();
      console.log(wrapRef.current.getBoundingClientRect())
      iframeRef.current.style.width = `${width}px`;
      iframeRef.current.style.height = `${height}px`;
    };

  }, [wrapRef.current, iframeRef.current, actived])
  return (
    <div ref={wrapRef} className={`pdfView ${actived ? 'actived' : ''}`}>
      <LoadingOutlined style={{ fontSize: '68px', color: '#fff' }} />

      <span className="flexible flex-align-center flex-justify-center closeBtn" onClick={onClose}>
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 8.75L13.75 5 15 6.25 11.25 10 15 13.75 13.75 15 10 11.25 6.25 15 5 13.75 8.75 10 5 6.25 6.25 5 10 8.75z"
            fill="currentColor"
          />
        </svg>
      </span>
      <ElectronComponentShow>
        <span className="flexible flex-align-center flex-justify-center downFileBtn" onClick={onDownFileClick}>
          <svg
            t="1591327334450"
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="10273"
            width="20"
            height="20"
          >
            <path
              d="M213.333333 853.333333 810.666667 853.333333 810.666667 768 213.333333 768M810.666667 384 640 384 640 128 384 128 384 384 213.333333 384 512 682.666667 810.666667 384Z"
              p-id="10274"
              fill="#F1F1F1"
            ></path>
          </svg>
        </span>
      </ElectronComponentShow>
      <iframe ref={iframeRef} allowtransparency="true" type="application/pdf" src={renderSrc} title="pdf"></iframe>
    </div>
  )
}

const NewFaxButton = withRouter((props) => {
  const onClick = () => {
    sa.Track('[panel]Menu_Click', { page: 'newfax' })
    props.onClick(props.history)
  }
  return (
    <a onClick={onClick} className="new-fax new-fax-btn flexible flex-align-center flex-justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path fill="#FFF" d="M7 7V2a2 2 0 114 0v5h5a2 2 0 110 4h-5v5a2 2 0 11-4 0v-5H2a2 2 0 110-4h5z" />
      </svg>
      NEW FAX
    </a>
  )
})

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      faxVisible: false,
      pdfSrc: '',
      sideFlag: true,
    }
  }
  setFaxVisible = () => {
    this.setState({
      faxVisible: true,
    })
  }

  requestData() {
    this.props.faxUsageStore.initial()
    this.props.userStore.initial()
  }

  componentDidMount() {
    window.addEventListener('click', this.removeTableClassName)

    if (IS_DEV) {
      this.requestData()
      return
    }

    if (IS_ELECTRON) {
      this.requestData()
      return
    }
    const token = getCookieToken()
    if (token) {
      this.requestData()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.removeTableClassName)
  }

  //移除表格 active 样式名
  removeTableClassName = () => {
    const trList = document.querySelectorAll('tr') || []
    trList.forEach((it) => {
      it.classList.remove('active')
    })
  }

  handlePdfSrc = (history, val) => {
    if (!val) {
      return
    }

    // 是否是 ipad 或者 ios
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      // 直接打开
      window.open(val)
      return;
    }

    this.setState({
      pdfSrc: val,
    })

    // history.push({ pathname: '/page/pdfview' })
  }
  closePdf = () => {
    this.setState({
      pdfSrc: '',
    })

    // history.back()
  }

  changeFaxCount = (obj) => {
    this.props.faxUsageStore.updateLocalData(obj)
    // this.setState({
    //   faxCountData: { ...this.state.faxCountData, ...obj },
    // })
  }

  downFilePdf = () => {
    const src = this.state.pdfSrc
    ipcSendCocoFaxAction('downloadURL', { src })
  }

  closeSide = () => {
    this.setState({
      sideFlag: !this.state.sideFlag,
    })
  }

  handleNewfax = (history) => {
    const { isUserHasNumber } = this.props.userStore
    if (!isUserHasNumber) {
      Modal.info({
        title: 'Notification',
        content: (
          <div>
            <p>Your fax number is not available. Please contact the admin of your team.</p>
          </div>
        ),
        okText: 'Confirm',
        onOk() { },
      })
      return
    }
    // 有号码则正常跳转
    history.push({ pathname: '/page/newfax' })
  }

  render() {
    const { data: faxCountData } = this.props.faxUsageStore
    const { userInfo: userData, phonesIsRequest: gotFaxNumber, isUserGroupMember } = this.props.userStore

    return (
      <>
        {isUserGroupMember ? null : <SubScriptionExpired />}

        {/* 路由 */}
        <BrowserRouter>
          {/* <Switch> */}
          {/* <Route exact path="/page/pdfview"> */}
          {/* PDF 预览 */}
          <PDFView src={this.state.pdfSrc} onClose={this.closePdf} onDownFileClick={this.downFilePdf} />
          {/* </Route> */}

          {/* <Route> */}
          <div className="flexible md-column" id="cms">
            <div className={this.state.sideFlag ? 'lft' : 'lft close-menu'}>
              <span className="md-block closeSidebar" onClick={this.closeSide}>
                {this.state.sideFlag ? <MenuCloseIcon /> : <MenuOpenIcon />}
              </span>
              {/* logo */}
              <div className="flexible logo" onClick={() => (window.location.href = Config.mainDomain)}>
                <LogoIcon />
              </div>
              <div className="menu-scroll-cont">
                {/* 菜单 */}
                <CustomMenu faxCountData={faxCountData} />
                {/* 标签 为了需求, 迁到Menu/index.js*/}
                {/* <Label /> */}
                {/* nexfax 按钮 */}
                <NewFaxButton onClick={this.handleNewfax} />
              </div>
            </div>
            <div className={this.state.sideFlag ? 'rgt md-width' : 'rgt md-width close-menu'}>
              <SearchTop />
              <ContentMain
                gotFaxNumber={gotFaxNumber}
                changeFaxCount={this.changeFaxCount.bind(this)}
                userData={userData}
                faxCountData={faxCountData}
                pdfSrc={this.handlePdfSrc}
              />
            </div>
          </div>
          {/* </Route> */}
          {/* </Switch> */}
        </BrowserRouter>
        {/* Modal */}
        {/* Desktop 端升级弹窗 */}
        <ElectronUpdater />

        {/* 标签 */}
        <AddToLabelModal />
        {/* 备注 */}
        <AddNoteModal />

        {isUserGroupMember ? null : (
          <>
            {/* 验证免费用户邮箱 */}
            <VerifyEmailModal />
            {/* 免费用户手动获取号码 */}
            <GetFreeNumberModal />
            {/* 免费号码过期 */}
            <FreeNumberExpiredModal />
          </>
        )}

        {/* 在线文档预览 */}
        <OnlineDocPreviewModal />
      </>
    )
  }
}

export default inject('faxUsageStore', 'userStore')(observer(App))
